// FONTE UNICA dei dati identificativi del titolare del trattamento.
// Per aggiornare (es. futuro trasferimento della sede legale camerale a Corso Francia 162),
// modificare ESCLUSIVAMENTE il valore `sedeLegale` qui sotto: le pagine /privacy e /termini
// si aggiornano automaticamente.
export const LEGAL = {
  brand: "MAS · Tricopigmentazione e Coworking Studio",
  brandShort: "MAS STUDIO",
  ragioneSociale: "MAS TRICO DI MARTORANO SEBASTIANO",
  formaGiuridica: "Impresa individuale",
  titolare: "Sebastiano Martorano",
  partitaIva: "13439880017",
  codiceFiscale: "MRTSST78D25L219B",
  rea: "TO - 1363056",
  pec: "sebastianomartorano@pec.it",
  // Sede legale = quella camerale ATTUALMENTE vigente. Aggiornare SOLO questo valore al futuro trasferimento.
  sedeLegale: "Via Massena Andrea 19/A, 10128 Torino (TO), Italia",
  sedeOperativa: "Corso Francia 162, 10098 Rivoli (TO), Italia",
  telefono: "371 523 3268",
  email: "mas.trico.torino@gmail.com",
  dominio: "https://tricomas.it",
  foro: "Foro di Torino, legge italiana (fatte salve le tutele inderogabili del consumatore)",
  lastUpdated: "02/06/2026",
};

// True: tutti i dati legali obbligatori sono verificati (visura camerale) e inseriti sopra.
export const LEGAL_PUBLISHABLE = true;

// Nessun dato legalmente indispensabile mancante.
export const LEGAL_MISSING = [];
